// extracted by extract-css-chunks-webpack-plugin
module.exports = {"fundDisplay":"group-gift-redemption-modal__fundDisplay__3T1s0","fund":"group-gift-redemption-modal__fund__1hmia"};